export default new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: 'USD'
});